import { Continuation as ContinuationModel } from '../models/continuation';
import Line from '@shared/components/Line';
import style from './Continuation.module.scss';
import classNames from 'classnames';

interface ContinuationProps {
  continuation: ContinuationModel;
}

export default function Continuation({ continuation }: ContinuationProps) {
  return (
    <div className={style.continuation}>
      <div className={style.continuation__visual}></div>
      <div className={style.continuation__information}>
        <div className={style['continue-as']}>Fortsätter som</div>
        <Line line={continuation.line} size="medium" />
        <div
          className={classNames(
            style.destination,
            continuation.destination.via && style['destination--has-via'],
          )}
        >
          <div className={style['destination__name']}>
            {continuation.destination.name}
          </div>
          {continuation.destination.via && (
            <div className={style['destination__via']}>
              via {continuation.destination.via}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
